module.exports = __webpack_public_path__ + "img/logo.183a9f13.png";